import React from 'react';
import { motion } from 'framer-motion';
import { volumeStages } from '../data/volumes';
export function SystemDifference() {
  return <section className="py-24 px-4 bg-pearl-light border-y border-pearl-dark" data-id="element-253" data-mp="30fanmmkx6ncx">
      <div className="max-w-5xl mx-auto" data-id="element-254" data-mp="3e65pvg0wy67j">
        <div className="text-center mb-12" data-id="element-255" data-mp="3e91nf38umsvg">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-4" data-id="element-256" data-mp="397ug15ambvpb">
            What Makes the 6-in-1 System Different?
          </h2>
          <p className="text-lg text-graphite" data-id="element-257" data-mp="2lkmdgv4kr0qz">
            Every volume is designed to help you move through a different stage of teaching.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-12" data-id="element-258" data-mp="2vhiop8luy0z8">
          {volumeStages.map((stage, index) => <motion.div key={stage.number} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.25,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white border-t-4 border-navy border-x border-b border-x-pearl-dark border-b-pearl-dark rounded-xl p-5" data-id="element-259" data-mp="2qjpgka0zuwwb" data-mpi={index}>
              <p className="text-gold-dark font-bold text-xs uppercase tracking-[0.2em] mb-2" data-id="element-260" data-mp="305y98dudcs4s">
                {stage.number}
              </p>
              <p className="text-navy font-medium text-sm" data-id="element-261" data-mp="3549hwl8xgwlf">{stage.stage}</p>
            </motion.div>)}
        </div>

        <div className="max-w-2xl mx-auto text-center" data-id="element-262" data-mp="27ewqy3vdqgh1">
          <p className="text-lg text-graphite mb-2" data-id="element-263" data-mp="2ch5iqwwinchk">
            You are not buying one ebook with 120 random lesson ideas.
          </p>
          <p className="text-xl font-bold text-navy" data-id="element-264" data-mp="2hd44ecqgmgea">
            You are getting six complete teaching resources that work together as one system.
          </p>
        </div>
      </div>
    </section>;
}